import basic from '../../data/basic';

export const BaitTypes = {
    AIM: Symbol('aim'),
    UNSELECTED: Symbol('unselected'),
    DEATH: Symbol('death')
};

// export const BaitCategoryTypes = {
//     FEMALE: 'female',
//     MALE: 'male'
// };

const getTeamsBaitTypes = () => {
    const result = {};

    basic.teams.forEach((team, index) => {
        result[`TEAM_${index + 1}`] = team.id;
    });

    return result;
};

export const BaitViewTypes = {
    ...getTeamsBaitTypes(),
    BALL: 'ball'
};
